import type { FiltersSearchType } from '@/common/api/types/itemFilters';

const OPEN_POSITION_PICKLIST_FILTERS = [
  'locationId',
  'roleId',
  'skillId',
  'teamId',
] as const satisfies readonly (keyof FiltersSearchType)[];

export const OPEN_POSITION_FILTER_KEYS = [...OPEN_POSITION_PICKLIST_FILTERS] as const;
export type OpenPositionFilterKey = (typeof OPEN_POSITION_FILTER_KEYS)[number];
